module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/bp-8-512.728d3415a8468b48.png"+" 512w",
        images: [{path: "https://static.sniffspot.com/packs/img/bp-8-512.728d3415a8468b48.png",width: 512,height: 341}],
        src: "https://static.sniffspot.com/packs/img/bp-8-512.728d3415a8468b48.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/bp-8-512.728d3415a8468b48.png"},
        
        width: 512,
        height: 341
      }